import { Skeleton, TableCell, TableRow } from '@mui/material';
import React from 'react';
import {
  ActionCell,
  ContactCell,
  DateCell,
  PriceCell,
  ReasonCell,
  RefCell,
  RefundCell,
  StatusCell,
} from './DashboardCells.jsx';
import { RetractDrawer } from './RetractDrawer.jsx';

const GetCell = ({ cell, data, _statusList }) => {
  let res = (
    <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
      <Skeleton variant="rectangular" width={80} height={30} />
    </TableCell>
  );
  switch (cell.code) {
    case 'REF':
      res = <RefCell data={data} key={data?._id} />;
      break;
    case 'DATE':
      res = <DateCell data={data} props={cell.props} key={data?._id} />;
      break;
    case 'CONTACT':
      res = <ContactCell data={data} props={cell.props} key={data?._id} />;
      break;
    case 'PRICE':
      res = <PriceCell data={data} props={cell.props} key={data?._id} />;
      break;
    case 'STATUS':
      res = <StatusCell data={data} props={cell.props} key={data?._id} />;
      break;
    case 'REASON':
      res = <ReasonCell data={data} props={cell.props} key={data?._id} />;
      break;
    case 'REFUND':
      res = <RefundCell data={data} props={cell.props} key={data?._id} />;
      break;
    case 'ACTION':
      res = (
        <>
          <ActionCell data={data} props={cell.props} key={data?._id}>
            <RetractDrawer />
          </ActionCell>
        </>
      );
      break;
    default:
      break;
  }
  return res;
};

export const GenerateRow = ({ order, table }) => {
  return (
    <TableRow>
      {table.map((item, index) => (
        <GetCell cell={item} data={order} key={`${item.code}-${index}`} />
      ))}
    </TableRow>
  );
};

export const LoadingRow = ({ table }) => {
  return (
    <TableRow>
      {table.map((item, index) => (
        <GetCell cell={''} data={null} key={`loading-${index}`} />
      ))}
    </TableRow>
  );
};
